import { RouterModule }  from "@angular/router";
import { UserHomeComponent } from "./userHome.component";
import { UserDetailsComponent } from "./userDetails";
import { UserForceSecretComponent } from "./userForceSecret.component";
import { ApplicationComponent } from "./applications";
import { ForceContactInfoUpdateComponent } from "./userDetails/forceContactInfoUpdate.component";

export const USERHOMEROUTING = RouterModule.forChild([
  { path: "myhome", component: UserHomeComponent },
  { path: "userDetails/:accountId/:userId", component: UserDetailsComponent },
  { path: "applications", component: ApplicationComponent },
  { path: "secret", component: UserForceSecretComponent },
  // added route to display the Contact Info form to force user to update their contact info
  { path: "forceContactInfoUpdate", component: ForceContactInfoUpdateComponent }
]);




// WEBPACK FOOTER //
// ./src/app/modules/userHome/userHome.route.ts